import { render, staticRenderFns } from "./studyLogin.vue?vue&type=template&id=2bfa28f6&scoped=true"
import script from "./studyLogin.vue?vue&type=script&lang=js"
export * from "./studyLogin.vue?vue&type=script&lang=js"
import style0 from "./studyLogin.vue?vue&type=style&index=0&id=2bfa28f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa28f6",
  null
  
)

export default component.exports